"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OriginArea = void 0;
var OriginArea;
(function (OriginArea) {
    OriginArea["AFTER_EFFECTS_PLUGIN"] = "AFTER_EFFECTS_PLUGIN";
    OriginArea["BROWSE_KEYWORDS"] = "BROWSE_KEYWORDS";
    OriginArea["FOLDERS"] = "FOLDERS";
    OriginArea["FOLDERS_RELATED_CONTENT"] = "FOLDERS_RELATED_CONTENT";
    OriginArea["MEMBER_STOCK_MEDIA_PAGE"] = "MEMBER_STOCK_MEDIA_PAGE";
    OriginArea["MORE_LIKE_THIS"] = "MORE_LIKE_THIS";
    OriginArea["SAME_SHOOT"] = "SAME_SHOOT";
    OriginArea["SAME_MODEL"] = "SAME_MODEL";
    OriginArea["SIMILAR_CLIPS"] = "SIMILAR_CLIPS";
    OriginArea["PLUGIN_SEARCH"] = "PLUGIN_SEARCH";
    OriginArea["PREMIERE_PRO_PLUGIN"] = "PREMIERE_PRO_PLUGIN";
    OriginArea["SEARCH"] = "SEARCH";
    OriginArea["SNAPSHOTS_VIDEO_THUMBNAIL"] = "SNAPSHOTS_VIDEO_THUMBNAIL";
    OriginArea["STOCK_DETAILS"] = "STOCK_DETAILS";
    OriginArea["STORYBOARD"] = "STORYBOARD";
    OriginArea["OUTDATED_SCHEMA"] = "OUTDATED_SCHEMA";
})(OriginArea = exports.OriginArea || (exports.OriginArea = {}));
//# sourceMappingURL=OriginAreaEnum.js.map